<template>

<div>


    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Användare
        <a href="/users/new" class="btn btn-default btn-sm">
          Lägg till
        </a>
    </h1>

    <div class="searchbar">

        <div>

            <div class="block" v-bind:class="{ active: search.active != null }">
                <label>
                    Visa:
                    <select v-model="search.deleted" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Aktiva</option>
                        <option v-bind:value="'deleted'">Inaktiva</option>
                    </select>
                </label>
            </div>

            <br clear="all">

        </div>

    </div>

</div>


</template>


<script>

    export default {
        props: {
            query: {
                required: true
            },
            loading: {}
        },
        data: function () {
            return {
                search: {

                }
            }
        },
        methods: {

            updateQuery: function() {

                this.$emit('search', this.search);

            }
        },
        watch: {
            query: function() {

                this.search = this.query;

            }
        }
    }

</script>
